// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CreditMemoClaimNumberCriteria from './claim-number-criteria';
import CreditMemoInvoiceRequestCriteria from './invoice-request-criteria';
import CreditMemoIssueDateCriteria from '../../../shared/components/date-criteria';
import Criteria from '../../state/criteria';

const CreditMemoSecondaryInputCriteriaSection = props =>
    <div className='credit-memo-secondary-input-criteria'>
        <CreditMemoClaimNumberCriteria
            claimNumberValue={props.criteria.claimNumber}
            handleClaimNumberInputChange={props.handleClaimNumberInputChange}
        />
        <CreditMemoIssueDateCriteria
            dateRange={props.criteria.dateIssued}
            label='CREDIT_MEMO_ISSUE_DATE'
            onDateChange={props.handleCreditMemoIssueDateSelect}
        />
        <CreditMemoInvoiceRequestCriteria
            handleInvoiceRequestInputChange={props.handleInvoiceRequestInputChange}
            invoiceRequest={props.criteria.invoiceRequest}
        />
    </div>;

CreditMemoSecondaryInputCriteriaSection.displayName = 'CreditMemoSecondaryInputCriteriaSection';
CreditMemoSecondaryInputCriteriaSection.propTypes = {
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    handleClaimNumberInputChange: PropTypes.func.isRequired,
    handleCreditMemoIssueDateSelect: PropTypes.func.isRequired,
    handleInvoiceRequestInputChange: PropTypes.func.isRequired
};

export default CreditMemoSecondaryInputCriteriaSection;



// WEBPACK FOOTER //
// ./src/reports/credit-memo/components/credit-memo-report-criteria/secondary-input-criteria-section.js